import React from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '../../constants';
import history from '../../history';

class Link extends React.PureComponent {
  static propTypes = {
    to: PropTypes.string,
    target: PropTypes.string,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
    underline: PropTypes.bool,
  };

  static defaultProps = {
    onClick: () => {},
    style: EMPTY_OBJECT,
    underline: false,
  };

  handleClick = event => {
    this.props.onClick(event);

    if (this.props.to === undefined) {
      event.preventDefault();
      return;
    }

    if (event.defaultPrevented === true) {
      return;
    }

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
      return;
    }

    if (isAbsoluteURL(this.props.to)) {
      return;
    }

    if (this.props.target === '_blank') {
      return;
    }

    event.preventDefault();
    history.push(this.props.to);
  };

  render() {
    // NOTE: target omitted on purpose.
    const {
      to,
      onClick,
      children,
      style,
      underline,
      ...otherProps
    } = this.props;

    const composedStyle = {
      cursor: 'pointer',
      textDecoration: 'none',
      color: 'inherit',
      ...style,
    };
    if (underline) {
      composedStyle['textDecoration'] = 'underline';
    }
    if (onClick && composedStyle.cursor === undefined) {
      composedStyle.cursor = 'pointer';
    }

    if (otherProps.target === undefined && isAbsoluteURL(to)) {
      otherProps.target = '_blank';
      otherProps.rel = 'noopener';
    }

    return (
      <a
        {...otherProps}
        style={composedStyle}
        href={to}
        onClick={this.handleClick}
      >
        {children}
      </a>
    );
  }
}

export default Link;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function isAbsoluteURL(url) {
  if (url === undefined) {
    return false;
  }

  if (url.indexOf('://') > -1) {
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./src/components/Link/Link.js